module.exports = __webpack_public_path__ + "static/media/card3_5.4611c422.png";